import { DateInput, DateInputProps } from '@mantine/dates'
import React from 'react'

export default function EDateInput(props: DateInputProps) {
  return (
    <DateInput
      {...props}
      styles={{
        input: {
          borderRadius: '8px',
          fontSize: '17px',
        },
        label: {
          marginBottom: '2px',
          fontWeight: 400,
          fontSize: '15px',
          color: '#374151',
        },
        error: {
          fontSize: '12px',
          marginTop: '4px',
        },
        ...props.styles as any,
      }}
    />
  )
}
